<mat-toolbar color="primary" class="apearAnimation flex-row flex content-between relative rounded-md">
  <span class="font-semibold">Historial de ordenes de compra</span>
  </mat-toolbar>
  
  <div class="margin-container apearAnimation">
  
    <div class="flex flex-wrap items-baseline bg-stone-100 rounded-md pt-3 px-1 mb-2">
  
      <mat-form-field appearance="outline" 
        class="example-full-width"
        style="padding-left: 10px; font-size: smaller"
      >
        <mat-label>Club</mat-label>
        <mat-select
          [(ngModel)]="clubSelect"
          (selectionChange)="cambioClubBuscar()"
        >
        <mat-option value="00000000-0000-0000-0000-000000000000"> Todos</mat-option>
          <mat-option *ngFor="let clubTmp of lstClubes" [value]="clubTmp.id">
            {{ clubTmp.nombre }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" style="padding-left: 10px; font-size: smaller; min-width: 250px;">
        <mat-label>Periodo de busqueda</mat-label>
        <mat-date-range-input [rangePicker]="picker">
          <input matStartDate [(ngModel)]="startDate" placeholder="Fecha desde" />
          <input matEndDate [(ngModel)]="endDate" placeholder="Fecha hasta" />
        </mat-date-range-input>
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-date-range-picker #picker></mat-date-range-picker>
      </mat-form-field>

      <button style="margin-left: 10px;" (click)='buscar()' mat-raised-button color="primary">Buscar</button>
 
    </div>


    <div class="loading-indicator" *ngIf="isLoadingResults">
      <mat-spinner></mat-spinner>
    </div>
  
    <mat-form-field appearance="outline">
      <mat-label>Filtro</mat-label>
      <input matInput (keyup)="applyFilter($event)" placeholder="Filtro" #input />
    </mat-form-field>
  
    <div class="mat-elevation-z0 contenedorTabla" *ngIf="!isLoadingResults">
      <table mat-table [dataSource]="dataSource">
  
        <ng-container matColumnDef="empresa">
          <th mat-header-cell *matHeaderCellDef>Club</th>
          <td mat-cell *matCellDef="let element">{{ element.empresa }}</td>
        </ng-container>

        <ng-container matColumnDef="fechaCreacion">
          <th mat-header-cell *matHeaderCellDef>Fecha Creación</th>
          <td mat-cell *matCellDef="let element">{{ element.fechaCreacion  | date: 'dd-MM-yyyy' }}</td>
        </ng-container>

        <ng-container matColumnDef="valor">
          <th mat-header-cell *matHeaderCellDef>Valor</th>
          <td mat-cell *matCellDef="let element">{{ element.valor  | currency: "":"symbol":"1.0-0" }}</td>
        </ng-container>

        <ng-container matColumnDef="fechaFinalizada">
          <th mat-header-cell *matHeaderCellDef>Fecha Finalizada</th>
          <td mat-cell *matCellDef="let element">{{ element.fechaFinalizada  | date: 'dd-MM-yyyy' }}</td>
        </ng-container>

        <ng-container matColumnDef="numeroRegistros">
          <th mat-header-cell *matHeaderCellDef>Número Registros</th>
          <td mat-cell *matCellDef="let element">{{ element.numeroRegistros }}</td>
        </ng-container>

        <ng-container matColumnDef="estado">
          <th mat-header-cell *matHeaderCellDef>Estado</th>
          <td mat-cell *matCellDef="let element">
            <label *ngIf="element.estado==0"> Creada </label>
            <label *ngIf="element.estado==1"> Presentada </label>
            <label *ngIf="element.estado==2"> Finalizada </label>
            <label *ngIf="element.estado==3"> Rechazada </label> 
          </td>
        </ng-container>

        <ng-container matColumnDef="botones">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element">

            <button
            color="primary"
            mat-icon-button
            aria-label="abre detalle de la orden de compra"
            (click)="abrirDetalleOrdenCompra(element)"
          >
            <mat-icon>receipt_long</mat-icon>
          </button>

            <button
            *ngIf="element.permiteRechazar"
           color="warn"
           mat-icon-button
           aria-label="Edit"
           (click)="rechazar(element)"
         >
           <mat-icon>cancel</mat-icon>
         </button> 
  
          </td>
        </ng-container>
  
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
  
      <mat-paginator
        #paginator
        [length]="length"
        [pageIndex]="pageIndex"
        [pageSize]="pageSize"
        [pageSizeOptions]="[10, 25, 100]"
        (page)="getServerData($event)"
      ></mat-paginator>
    </div>
  </div>
  